// extracted by mini-css-extract-plugin
export default {"knowAboutPcp":"responsiveStyles_knowAboutPcp__OiZgH","twoCols":"responsiveStyles_twoCols__mpIni","facts":"responsiveStyles_facts__HV1Bm","fact":"responsiveStyles_fact__0nPgS"};